import type { Provider } from '../types';
import { providerLabels } from '../data';

const monograms: Record<Provider, string> = {
  tiktok: 'TT',
  facebook: 'f',
  instagram: '◎',
  youtube: '▶',
};

interface PlatformBadgeProps {
  provider: Provider;
  label?: boolean;
  muted?: boolean;
}

export function PlatformBadge({ provider, label = false, muted = false }: PlatformBadgeProps) {
  return (
    <span className={`platform-badge platform-badge--${provider} ${muted ? 'is-muted' : ''}`} title={providerLabels[provider]}>
      <span className="platform-badge__icon" aria-hidden="true">{monograms[provider]}</span>
      {label && <span>{providerLabels[provider]}</span>}
    </span>
  );
}

